import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"
import { RadioGroupItem, RadioGroupLabel } from "@/components/ui/radio-group"

interface RadioGroupItemCustomProps extends React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> {
  value: string
  groupName: string
  label: string
}

const RadioGroupItemCustom = ({ value, groupName, label, ...props }: RadioGroupItemCustomProps) => {
  return (
    <RadioGroupItem
      key={value}
      data-testid={`${groupName}-${value}-item`}
      className="px-1 py-1.5"
      value={value}
      {...props}>
      <RadioGroupLabel data-testid={`${groupName}-${value}-label`}>{label}</RadioGroupLabel>
    </RadioGroupItem>
  )
}

export { RadioGroupItemCustom }
